import { Controller } from "@hotwired/stimulus"

// Generic click-to-sort for server-rendered tables (Sub Payments list,
// Phelipe 2026-08-19). Headers carry data-key (+ data-type="num" for money/
// counts); rows carry matching data-s-<key> attributes with raw values, so
// "$29,490.00" and "—" sort by number, not by string.
export default class extends Controller {
  sort(e) {
    const th = e.currentTarget
    const key = th.dataset.key
    if (!key) return

    const numeric = th.dataset.type === "num"
    const dir = th.dataset.dir === "asc" ? "desc" : "asc"
    this.element.querySelectorAll("th[data-key]").forEach((h) => {
      delete h.dataset.dir
      h.querySelector("[data-sort-arrow]")?.remove()
    })
    th.dataset.dir = dir
    const arrow = document.createElement("span")
    arrow.setAttribute("data-sort-arrow", "")
    arrow.className = "ml-0.5 text-gray-400"
    arrow.textContent = dir === "asc" ? "▲" : "▼"
    th.appendChild(arrow)

    const body = this.element.querySelector("tbody")
    if (!body) return
    const rows = [...body.querySelectorAll(`tr[data-s-${key}]`)]
    const val = (row) => {
      const raw = row.getAttribute(`data-s-${key}`) || ""
      if (!numeric) return raw.toLowerCase()
      const n = parseFloat(raw)
      return isNaN(n) ? -Infinity : n
    }
    rows.sort((a, b) => {
      const av = val(a), bv = val(b)
      const cmp = numeric ? av - bv : (av < bv ? -1 : av > bv ? 1 : 0)
      return dir === "asc" ? cmp : -cmp
    })
    rows.forEach((r) => body.appendChild(r))
  }
}
